import PubSub from 'pubsub-js'

function publish(event, data) {
  PubSub.publish(event, data)
}

function subscribe(event, callback) {
  return PubSub.subscribe(event, (options, data) => {
    callback(options, data)
  })
}

function unSubscribeEvent(token) {
  PubSub.unsubscribe(token)
}

export { publish, subscribe, unSubscribeEvent }
